import { Link } from 'react-router-dom';
import { categories } from '@/mocks/collections';

export default function CategoryNav() {
  return (
    <section id="categories" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs md:text-sm label-font text-primary-600 tracking-[0.2em]">
              CATEGORIES
            </span>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              按主题分类逛专题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
              六个方向覆盖绝大多数娱乐话题，选中你感兴趣的方向，直接看这一类已打包好的合集。
            </p>
          </div>
          <Link
            to="/collections"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-foreground-300 text-sm label-font text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap self-start md:self-auto"
          >
            查看全部专题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/collections?category=${cat.slug}`}
              className="group flex gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-accent-400 transition-colors"
            >
              <span className="shrink-0 w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="flex-1">
                <span className="flex items-center justify-between">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                    {cat.name}
                  </h3>
                  <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
                </span>
                <span className="mt-1 block text-sm text-foreground-600 leading-relaxed">
                  {cat.desc}
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}